import { PlatformApiClient } from '@fourthwall/services/dist/PlatformApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useFeatureFlagsQuery = createQueryHook(PlatformApiClient.getFeatureFlags, {
  queryKey: ['featureFlags'],
})
